import { Command } from 'hooks/useCommand'
import React from 'react'

export const CommandsContext = React.createContext(
  {} as {
    commands: Command[]

    addCommand: (command: Command) => () => void
    removeCommand: (command: Command) => void
  }
)
